function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5644 45.2332C69.16 32.3643 70.0533 19.1732 66.0022 12.971C61.9511 6.76876 49.8778 -3.92458 21.3511 14.7088C-7.17556 33.3421 0.0799969 53.5976 4.53778 60.4176C25.4 92.3554 92.4511 68.0243 77.5644 45.2332Z",
  fill: "#F7F7F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M65 41.6666V56.1111C65 58.5555 63 60.5555 60.5556 60.5555H19.4444C17 60.5555 15 58.5555 15 56.1111V41.6666H23.3556C24.3333 41.6666 25.2 42.3111 25.4667 43.2444L27.8667 51.2C28.1333 52.1333 29 52.7777 29.9778 52.7777H50.0222C51 52.7777 51.8667 52.1333 52.1333 51.2L54.5333 43.2444C54.8 42.3111 55.6667 41.6666 56.6444 41.6666H65Z",
  fill: "#F3F3F1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M65 41.6667H56.6444C55.6667 41.6667 54.8 42.3111 54.5333 43.2445L52.1333 51.2C51.8667 52.1333 51 52.7778 50.0222 52.7778H29.9778C29 52.7778 28.1333 52.1333 27.8667 51.2L25.4667 43.2445C25.2 42.3111 24.3333 41.6667 23.3556 41.6667H15L25 19.4445H55L65 41.6667Z",
  fill: "#E7F5FE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M57.1334 51.2L59.5334 43.2444C59.8001 42.3111 60.6668 41.6666 61.6445 41.6666H56.6445C55.6668 41.6666 54.8001 42.3111 54.5334 43.2444L52.1334 51.2C51.8668 52.1333 51.0001 52.7777 50.0223 52.7777H55.0223C56.0001 52.7777 56.8668 52.1333 57.1334 51.2Z",
  fill: "#D5DBE1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20 56.1111V41.6666H15V56.1111C15 58.5555 17 60.5555 19.4444 60.5555H24.4444C22 60.5555 20 58.5555 20 56.1111Z",
  fill: "#D5DBE1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25 19.4445L15 41.6667H20L30 19.4445H25Z",
  fill: "#B6E2FB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8667 51.2L30.4667 43.2444C30.2 42.3111 29.3333 41.6666 28.3556 41.6666H23.3556C24.3333 41.6666 25.2 42.3111 25.4667 43.2444L27.8667 51.2C28.1333 52.1333 29 52.7777 29.9778 52.7777H34.9778C34 52.7777 33.1333 52.1333 32.8667 51.2Z",
  fill: "#B6E2FB"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M61.6533 14.4445C59.8156 14.4445 58.32 12.9489 58.32 11.1112C58.32 9.27339 59.8156 7.77783 61.6533 7.77783C63.4911 7.77783 64.9867 9.27339 64.9867 11.1112C64.9867 12.9489 63.4911 14.4445 61.6533 14.4445ZM61.6533 10.0001C61.04 10.0001 60.5422 10.5001 60.5422 11.1112C60.5422 11.7223 61.04 12.2223 61.6533 12.2223C62.2667 12.2223 62.7645 11.7223 62.7645 11.1112C62.7645 10.5001 62.2667 10.0001 61.6533 10.0001Z",
  fill: "#75768A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6512 10.7103L17.2225 9.13898L20.3652 12.2817L18.7939 13.853L15.6512 10.7103Z",
  fill: "#75768A"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2552 21.318L18.3979 18.1753L19.9693 19.7466L16.8266 22.8893L15.2552 21.318Z",
  fill: "#75768A"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M24.2924 12.2825L27.4351 9.13977L29.0064 10.7111L25.8637 13.8538L24.2924 12.2825Z",
  fill: "#75768A"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M60.5555 62.2222H19.4444C16.0733 62.2222 13.3333 59.4822 13.3333 56.111V41.6666C13.3333 41.431 13.3822 41.1977 13.48 40.9822L23.48 18.7599C23.7489 18.1622 24.3444 17.7777 25 17.7777H55C55.6555 17.7777 56.2511 18.1622 56.52 18.7599L66.52 40.9822C66.6178 41.1977 66.6666 41.431 66.6666 41.6666V56.111C66.6666 59.4822 63.9266 62.2222 60.5555 62.2222ZM16.6666 42.0244V56.111C16.6666 57.6422 17.9133 58.8888 19.4444 58.8888H60.5555C62.0866 58.8888 63.3333 57.6422 63.3333 56.111V42.0244L53.9222 21.111H26.0778L16.6666 42.0244Z",
  fill: "#75768A"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M50.0133 54.4444H29.9867C28.2578 54.4444 26.76 53.3311 26.2622 51.6733L23.8778 43.7311C23.8067 43.4978 23.5889 43.3333 23.3467 43.3333H15V40H23.3467C25.0756 40 26.5733 41.1133 27.0711 42.7711L29.4556 50.7133C29.5267 50.9489 29.7444 51.1111 29.9867 51.1111H50.0133C50.2556 51.1111 50.4756 50.9489 50.5444 50.7133L52.9289 42.7711C53.4267 41.1133 54.9222 40 56.6533 40H65V43.3333H56.6533C56.4111 43.3333 56.1911 43.4956 56.1222 43.7311L53.7378 51.6733C53.24 53.3311 51.7422 54.4444 50.0133 54.4444Z",
  fill: "#75768A"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M4.44453 58.8888H75.5556V62.2221H4.44453V58.8888Z",
  fill: "#75768A"
});

function SvgVisualEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualEmpty);
export default __webpack_public_path__ + "static/media/visual-empty.82201997.svg";
export { ForwardRef as ReactComponent };